const resizeObserver = new ResizeObserver(() => {
    adjustWizardStep();
});

window.adjustWizardStep = function () {
    setTimeout(function () {
        $(".tab-content").css('height', 'auto');
        $(".tab-pane").css('width', '100%');
    }, 50);
};

let domain = '';

window.SignUp = {
    init() {
        this.initWizard();
        this.validateEmailForm();
        this.validatePersonalDetailsForm();
    },
    emailVerifiedMsg() {
        return `Your account is already created please log in to continue.`
    },
    emailProviderMsg() {
        return `We do not allow email addresses from ${domain}. Please use your company email to create an account.`
    },

    initWizard() {
        $('#registration-smartwizard').smartWizard({
            theme: "square",
            justified: true,
            autoAdjustHeight: false,
            enableURLhash: false,
            transition: {
                animation: 'fade',
                speed: '400',
                easing: ''
            },
            keyboard: {
                keyNavigation: false
            },
            toolbar: {
                position: 'bottom',
                showNextButton: true,
                showPreviousButton: true,
                extraHtml: `<button id="finish-btn" class="btn primary-button" style="display: none;">Continue</button>`
            },
            anchor: {
                enableNavigation: false,
                enableNavigationAlways: false,
                enableDoneState: true,
                markPreviousStepsAsDone: true,
                unDoneOnBackNavigation: true
            },
            lang: {
                next: 'Next →',
                previous: '← Previous'
            }
        });

        $("#registration-smartwizard").on("showStep", function (e, anchorObject, stepIndex, stepDirection, stepPosition) {
            switch (stepIndex) {
                case 0:
                    if (window.analytics) {
                        window.analytics.page("", ANALYTICS_EVENTS.USER_TYPE_PAGE_VIEWED);
                    }
                    break
                case 1:
                    if (window.analytics) {
                        window.analytics.page("", ANALYTICS_EVENTS.SUPPLIER_EMAIL_PAGE_VIEWED);
                    }
                    break
                case 2:
                    if (window.analytics) {
                        window.analytics.page("", ANALYTICS_EVENTS.USER_DETAILS_PAGE_VIEWED);
                    }
                    break
                case 3:
                    const prevButton = document.getElementsByClassName('sw-btn-prev')[0];
                    prevButton.disabled = true;

                    const toolbar = document.getElementsByClassName('sw-toolbar-elm')[0];
                    toolbar.hidden = true;

                    $.ajax({
                        type: 'GET',
                        url: '/users/registration/company_details'
                    });

                    break
            }
        });

        var skipLeaveStep = false;
        $("#registration-smartwizard").on("leaveStep", function (e, anchorObject, currentStepIndex, nextStepIndex, stepDirection) {
            if (skipLeaveStep) {
                skipLeaveStep = false;
                return true;
            }

            if (stepDirection !== "forward") {
                return true;
            }
            let valid = [];
            if (currentStepIndex === 0) {
                function getUserType() {
                    const checkboxes = document.querySelectorAll('input[type="checkbox"]');
                    for (let checkbox of checkboxes) {
                        if (checkbox.checked) return checkbox.id;
                    }
                    return "";
                }

                if (window.analytics) {
                    window.analytics.track(ANALYTICS_EVENTS.USER_TYPE_SUBMITTED, {
                        user_type: getUserType()
                    });
                }

                const buyerCheckbox = document.getElementById('buyer');
                const supplierCheckbox = document.getElementById('supplier');

                valid.push(buyerCheckbox.checked || supplierCheckbox.checked);
                if (!valid.every(Boolean)) {
                    return false
                }

                if (buyerCheckbox.checked) {
                    window.location.replace('https://www.kwayga.com/book-a-demo');
                }
            } else if (currentStepIndex === 1) {
                const userRegistrationForm = document.getElementById("user-registration-form");
                if (window.analytics) {
                    window.analytics.track(ANALYTICS_EVENTS.SUPPLIER_EMAIL_SUBMITTED, {
                        email: userRegistrationForm.elements["user[email]"].value,
                        email_confirm: userRegistrationForm.elements["user[confirm_email]"].value
                    });
                }
                valid.push($('#user-registration-form').valid());

                if (!valid.every(Boolean)) {
                    return false
                }
            } else if (currentStepIndex === 2) {
                const personalDetailsForm = document.getElementById("personal-detail-form");
                if (window.analytics) {
                    window.analytics.track(ANALYTICS_EVENTS.USER_DETAILS_SUBMITTED, {
                        first_name: personalDetailsForm.elements["user[first_name]"].value,
                        last_name: personalDetailsForm.elements["user[last_name]"].value,
                        marketing_accepted: personalDetailsForm.elements["user[marketing_email_consent]"].checked,
                        terms_accepted: personalDetailsForm.elements["user[agree_terms]"].checked,
                    });
                }

                valid.push($('#personal-detail-form').valid());
                if (!valid.every(Boolean)) {
                    return false
                } else {
                    const data = {
                        'user[first_name]': personalDetailsForm.elements["user[first_name]"].value,
                        'user[last_name]': personalDetailsForm.elements["user[last_name]"].value,
                        'user[email]': $('#user-registration-form [name="user[email]"]').val(),
                        'user[password]': personalDetailsForm.elements["user[password]"].value,
                        'user[marketing_email_consent]': personalDetailsForm.elements["user[marketing_email_consent]"].checked,
                        'user[agree_terms]': personalDetailsForm.elements["user[agree_terms]"].checked,
                    }

                    $.ajax({
                        type: 'POST',
                        url: '/personal-details',
                        data: data,
                        success: function () {
                            skipLeaveStep = true;
                            $('#registration-smartwizard').smartWizard('next');
                        }
                    });

                    return false;
                }
            } else if (currentStepIndex === 3) {
            }

            return !valid.includes(false);
        });

        if (document.querySelector('#step-1') != null) {
            resizeObserver.observe(document.querySelector('#step-1'));
            resizeObserver.observe(document.querySelector('#step-2'));
            resizeObserver.observe(document.querySelector('#step-3'));
            resizeObserver.observe(document.querySelector('#step-4'));
        }
    },

    validateEmailForm() {
        $("#user-registration-form").validate({
            onsubmit: true,
            onkeyup: false,
            onclick: false,
            rules: {
                "user[email]": {
                    required: true,
                    checkEmail: true,
                    checkEmailDomain: true,
                    emailVerified: true
                },
                "user[confirm_email]": {
                    required: true,
                    equalTo: '#email'
                }
            },
            messages: {
                "user[email]": {
                    checkEmail: 'Email already taken'
                },
                "user[confirm_email]": {
                    equalTo: 'Please enter the same email.'
                }
            },
            errorPlacement: (error, element) => {
                error.insertAfter(element.parent());
            },
            onfocusout: function (element) {
                return $(element).valid();
            }
        });

        $.validator.addMethod("checkEmail", function (value) {
            var alreadyTaken = false
            $.ajax({
                url: `/users/registration/check_email`,
                data: {check_exists: true, 'user[email]': value},
                dataType: 'json',
                async: false,
                success: function (data) {
                    alreadyTaken = data
                }
            });
            return alreadyTaken;
        });

        $.validator.addMethod("equalTo", function (value, element, param) {
            return this.optional(element) || value.toLowerCase() === $(param).val().toLowerCase();
        }, 'Please enter the same email.');

        $.validator.addMethod("checkEmailDomain", function (value) {
            let emailProvider = false
            domain = value.split("@")[1]
            $.ajax({
                url: `/users/registration/check_email_domain`,
                data: {'user[email]': value},
                dataType: 'json',
                async: false,
                success: function (data) {
                    emailProvider = data;
                }
            });
            return emailProvider;
        }, this.emailProviderMsg);

        $.validator.addMethod("emailVerified", function (value) {
            var alreadyconfirmed = false
            $.ajax({
                url: `/users/registration/check_email_verified`,
                data: {'user[email]': value},
                dataType: 'json',
                async: false,
                success: function (data) {
                    alreadyconfirmed = data
                }
            });
            if (!alreadyconfirmed) {
                // window.location.replace(`/verify-email?email=${value}`)
            } else {
                return alreadyconfirmed;
            }
        }, this.emailVerifiedMsg);
    },

    validatePersonalDetailsForm() {
        $("#personal-detail-form").validate({
            onsubmit: true,
            onkeyup: false,
            onclick: false,
            rules: {
                "user[password]": {
                    required: true,
                    minlength: 8,
                    checklower: true,
                    checkupper: true,
                    checkdigit: true,
                    checkspecial: true
                },
                "user[confirm_password]": {
                    required: true,
                    equalTo: '#pass_log_id'
                },
                "user[first_name]": {
                    required: true,
                    minlength: 2,
                    maxlength: 50
                },
                "user[last_name]": {
                    required: true,
                    minlength: 2,
                    maxlength: 50
                },
                "user[agree_terms]": {
                    required: true
                }
            },
            messages: {
                "user[agree_terms]": {
                    required: " Please agree to our Terms and Conditions."
                },
                "user[password]": {
                    checkspecial: "Must contain at least 1 special character @$!%*#?&",
                    checklower: "Must contain at least 1 lowercase character",
                    checkupper: "Must contain at least 1 uppercase character",
                    checkdigit: "Must contain at least 1 number"
                },
                "user[confirm_password]": {
                    equalTo: 'Please enter the same password.'
                }
            },
            errorPlacement: (error, element) => {
                if (element.attr('name') === 'user[agree_terms]'
                    || element.attr('name') === 'user[password]'
                    || element.attr('name') === 'user[confirm_password]') {
                    error.insertAfter(element.parent());
                } else {
                    error.insertAfter(element);
                }
            },
            onfocusout: function (element) {
                return $(element).valid();
            }
        });

        $.validator.addMethod("checklower", function (value) {
            return /[a-z]/.test(value);
        });
        $.validator.addMethod("checkupper", function (value) {
            return /[A-Z]/.test(value);
        });
        $.validator.addMethod("checkdigit", function (value) {
            return /[0-9]/.test(value);
        });
        $.validator.addMethod("checkspecial", function (value) {
            return /[@$!%*#?&]/.test(value);
        });
        $.validator.addMethod("checkPresence", function (value) {
            return value && value.length > 0;
        });
    }
};
